import React, { useState, useContext } from "react"
import { RootContext } from "RootContext"

// Core components
import Box from "@material-ui/core/Box"
import Button from "@material-ui/core/Button"
import JSZip from "jszip"
import { saveAs } from "file-saver"

// pegaso views/components
import Card from "components/Card/Card.js"
import CardBody from "components/Card/CardBody.js"
import CardHeader from "components/Card/CardHeader.js"
import ErrorUtils from "components/Tools/ErrorUtils"
import { fetchWithToken } from "components/Fetch/api-fetch"

export default function ExportJobs() {
    const {
        companyId,
        t,
        apiUrl,
        getLab,
        access_token,
        refresh_token,
        setAccess_token
    } = useContext(RootContext)

    const [loading, setLoading] = useState(false)
    const { labId } = getLab()

    const fetchJobs = async () => {
        setLoading(true)

        const url = `${apiUrl}/companies/${companyId}/labs/${labId}/jobsAll`

        fetchWithToken(url, {
            method: "GET",
            apiUrl: apiUrl,
            companyId: companyId,
            access_token: access_token,
            refresh_token: refresh_token,
            setAccess_token: setAccess_token,
            streaming: true,
            headers: {
                Accept: "application/x-ndjson"
            }
        })
            .then(async (response) => {
                try {
                    const raw =
                        typeof response.text === "function"
                            ? await response.text()
                            : response?.body || ""

                    const jobs = raw
                        .split("\n")
                        .filter(line => line.trim().length > 0)
                        .map(line => {
                            try {
                                const job = JSON.parse(line)
                 
                                if (job?.shape?.original) {
                                    try {
                                        job.shape.original = atob(job.shape.original)
                                    } catch {
                                        job.shape.original = null
                                    }
                                }

                                if (job?.shape?.standard) {
                                    try {
                                        job.shape.standard = atob(job.shape.standard)
                                    } catch {
                                        job.shape.standard = null
                                    }
                                }

                                return job
                            } catch {
                                return null
                            }
                        })
                        .filter(Boolean)

                    // ZIP EXPORT SUBITO DOPO GET
                    const zip = new JSZip()

                    jobs.forEach(job => {
                        const fileName = `${job.year}_${job.jobId}.json`
                        zip.file(fileName, JSON.stringify(job, null, 2))
                    })

                    const blob = await zip.generateAsync({ type: "blob" })
                    const timestamp = new Date().toISOString().replace(/[-:T.Z]/g, "").replace(/(\d{8})(\d{6})/, "$1-$2")
                    saveAs(blob, `${timestamp}_jobs_export.zip`)
                } catch (e) {
                    ErrorUtils.errorLog(`${url} => parse error`, e.message)
                }
            })
            .catch(err => {
                ErrorUtils.errorLog(`${url} => ExportJobs Error`, err.message)
            })
            .finally(() => {
                setLoading(false)
            })
    }

    return (
        <div>
            <Card>
                <CardHeader color="primary">
                    <h4>{t("10473")}</h4>
                </CardHeader>
                <CardBody>
                    <Box display="flex" justifyContent="flex-start">
                        <Box p={1}>
                            <Button
                                variant="outlined"
                                color="secondary"
                                onClick={fetchJobs}
                                disabled={loading}
                            >
                                {loading ? t("10472") : t("10471")}
                            </Button>
                        </Box>
                    </Box>
                </CardBody>
            </Card>
        </div>
    )
}